/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .factory('AccountProfileService', AccountProfileService);

    AccountProfileService.$inject = ['$resource', 'DateUtils'];

    function AccountProfileService ($resource, DateUtils) {
        var service = $resource('api/member/profile', {}, {
            'get': { method: 'GET', params: {}, isArray: false,
                interceptor: {
                    response: function(response) {
                        // expose response
                        response.data.isafDate = DateUtils.convertLocalDateFromServer(response.data.isafDate);
                        response.data.idExpirationDate = DateUtils.convertLocalDateFromServer(response.data.idExpirationDate);
                        return response;
                    }
                }
            }
        });

        return service;
    }
})();
